class SingleInterview {
  constructor(el, opt) {
    this.el = el;
    if ($('.' + this.el).length > 0) {
      this.event();
    }
  }

  initLoopAutoSwiper({
    swiperSelector,
    prevSelector,
    nextSelector,
    currentSelector,
    totalSelector,
    spaceBetween,
    spaceBetweenMobile,
  }) {
    const swiperEl = document.querySelector(swiperSelector);
    if (!swiperEl) return null;

    const wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (!wrapper) return null;

    const originalSlides = Array.from(
      wrapper.querySelectorAll(':scope > .swiper-slide')
    );
    const originalCount = originalSlides.length;
    if (originalCount === 0) return null;

    const containerW = swiperEl.getBoundingClientRect().width;
    const slideW = originalSlides[0]
      ? originalSlides[0].getBoundingClientRect().width
      : 0;

    const gapForLoop =
      spaceBetweenMobile != null
        ? Math.min(spaceBetween, spaceBetweenMobile)
        : spaceBetween;

    const approxVisible =
      slideW > 0 && containerW > 0
        ? (containerW + gapForLoop) / (slideW + gapForLoop)
        : 2;

    const minLoopSlides = Math.max(
      10,
      Math.ceil(approxVisible) * 2 + 6,
      originalCount * 3
    );

    let cloneCursor = 0;
    while (wrapper.querySelectorAll('.swiper-slide').length < minLoopSlides) {
      const src = originalSlides[cloneCursor % originalCount];
      const clone = src.cloneNode(true);
      clone.classList.add(`${swiperSelector.replace(/^\./, '')}-clone`);
      wrapper.appendChild(clone);
      cloneCursor += 1;
    }

    const swiperOptions = {
      loop: true,
      loopAdditionalSlides: originalCount,
      slidesPerView: 'auto',
      spaceBetween,
      centeredSlides: true,
      centeredSlidesBounds: true,
      centerInsufficientSlides: true,
      speed: 500,
      watchSlidesProgress: true,
      roundLengths: true,
      watchOverflow: true,
      navigation: {
        nextEl: nextSelector,
        prevEl: prevSelector,
      },
    };

    if (spaceBetweenMobile != null) {
      swiperOptions.spaceBetween = spaceBetweenMobile;
      swiperOptions.breakpoints = {
        768: {
          spaceBetween,
        },
      };
    }

    const instance = new Swiper(swiperSelector, swiperOptions);

    const currentEl = document.querySelector(`${currentSelector} .current`);
    const totalEl = document.querySelector(`${totalSelector} .total`);
    const formatNumber = (num) => String(num).padStart(2, '0');

    const updatePagination = () => {
      const idx =
        ((instance.realIndex % originalCount) + originalCount) % originalCount;
      if (currentEl) currentEl.textContent = formatNumber(idx + 1);
      if (totalEl) totalEl.textContent = formatNumber(originalCount);
    };

    updatePagination();
    instance.on('slideChange', updatePagination);

    return instance;
  }

  event() {
    this.initLoopAutoSwiper({
      swiperSelector: '.work-swiper',
      prevSelector: '.work-swiper-button-prev',
      nextSelector: '.work-swiper-button-next',
      currentSelector: '.work-swiper-pagination',
      totalSelector: '.work-swiper-pagination',
      spaceBetween: 40,
    });

    this.initLoopAutoSwiper({
      swiperSelector: '.others-swiper',
      prevSelector: '.others-swiper-button-prev',
      nextSelector: '.others-swiper-button-next',
      currentSelector: '.others-swiper-pagination',
      totalSelector: '.others-swiper-pagination',
      spaceBetween: 30,
      spaceBetweenMobile: 15,
    });
  }
}
